import { render } from "./currency_input.vue?vue&type=template&id=65ef4f9a"
import script from "./currency_input.vue?vue&type=script&lang=js"
export * from "./currency_input.vue?vue&type=script&lang=js"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__